import { breakpoints, Button } from '@etg/wings';
import { Heart } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';

const saveTripButtonWrapperStyles = css`
  align-items: center;
  display: flex;
  gap: 8px;
  height: 48px;
  justify-content: center;
  padding: 0 16px;
  width: fit-content;
  z-index: 1;

  @media (max-width: ${breakpoints._970}) {
    bottom: 25px;
    left: 50%;
    position: fixed;
    transform: translateX(-50%);
  }

  @media (min-width: ${breakpoints._768}) and (max-width: ${breakpoints._970}) {
    width: 245px;
  }
`;

interface SaveTripButtonProps {
  onClick: () => void;
  savedTripsLength: number;
}

const SaveTripButton = ({ onClick, savedTripsLength }: SaveTripButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      className={saveTripButtonWrapperStyles}
      onClick={onClick}
      variant={savedTripsLength ? 'primary' : 'secondary'}
    >
      <Heart
        color="#ff4957"
        data-testid="heart"
        size={20}
        weight={savedTripsLength > 0 ? 'fill' : 'light'}
      />
      {savedTripsLength > 0 && <span>{savedTripsLength}</span>}
      <p data-testid="savedTrip-counter">{t('Result.SaveTrip.Button.Text')}</p>
    </Button>
  );
};

export default SaveTripButton;
